export enum fileTypeEnum {
	signable = 'signable_document',
	attachment = 'attachment'
}